<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-file-text-o'"></top-line>
    <div class="back-button">
      <el-button @click="goBack" icon="el-icon-arrow-left">返回</el-button>
    </div>
    
    <el-card shadow="never" class="detail-card">
      <div slot="header" class="clearfix">
        <span>订单详情</span>
      </div>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">订单名称：</span>
            <span class="detail-value">{{ orderDetail.order_no }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">客户名称：</span>
            <span class="detail-value">{{ orderDetail.customer_name }}</span>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 15px;">
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">资源类型：</span>
            <span class="detail-value">{{ orderDetail.resource_type }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">订单类型：</span>
            <span class="detail-value">{{ formatOrderType(orderDetail.order_type) }}</span>
          </div>
        </el-col>
      </el-row>

      

      <el-row :gutter="20" style="margin-top: 15px;">
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">账单日：</span>
            <span class="detail-value">{{ orderDetail.billing_day }} 号</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">订单状态：</span>
            <span class="detail-value">{{ formatStatus(orderDetail.status) }}</span>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 15px;">
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">货币类型：</span>
            <span class="detail-value">{{ orderDetail.currency }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">总价：</span>
            <span class="detail-value">{{ orderDetail.total_price }}</span>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 15px;">
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">设备数量：</span>
            <span class="detail-value">{{ orderDetail.dev_number }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">已交付数量：</span>
            <span class="detail-value">{{ orderDetail.delivered_number }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 15px;">
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">订单起始时间：</span>
            <span class="detail-value">{{ orderDetail.starting_time }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="detail-label">订单结束时间：</span>
            <span class="detail-value">{{ orderDetail.end_time }}</span>
          </div>
        </el-col>
      </el-row>

      <!-- 价格明细列表 -->
      <el-row style="margin-top: 30px;">
        <el-col :span="24">
          <div class="detail-title">
            <h3>价格明细：</h3>
          </div>
          <el-table
            :data="orderDetail.price_items || []"
            border
            style="width: 100%; margin-top: 10px;"
            :default-sort="{ prop: 'name', order: 'ascending' }"
          >
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="name" label="收费项目名称" min-width="80" sortable></el-table-column>
            <el-table-column prop="specifications" label="规格" min-width="90"></el-table-column>
            <el-table-column prop="dev_character" label="资源类型" min-width="90"></el-table-column>

            <!-- 单位：根据 dev_character 动态映射 -->
            <el-table-column label="单位" min-width="90">
              <template slot-scope="scope">
                {{ getMeteringUnitLabel(scope.row) }}
              </template>
            </el-table-column>

            <!-- 直接展示后端返回的单价 -->
            <el-table-column prop="unit_price" label="单价(元)" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.unit_price  }}
              </template>
            </el-table-column>
            <!-- 状态：下拉选择启用/禁用 -->
            <el-table-column label="状态" min-width="90">
              <template slot-scope="scope">
                <span :class="scope.row.status === 1 ? 'status-enabled' : 'status-disabled'">
                  {{ formatStatusText(scope.row.status) }}
                </span>
              </template>
            </el-table-column>

            <!-- 备注 -->
            <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <!-- 操作按钮区域 -->
      <el-row style="margin-top: 30px; text-align: center;">
        <el-button @click="goBack">返回</el-button>
      </el-row>
    </el-card>
  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";

export default {
  name: "OrderShowDetails",
  components: {
    topLine
  },
  data() {
    return {
      pageTitle: "订单详情",
      orderId: null,
      orderDetail: {},
      // 从列表页传递过来的分页信息
      fromPage: 1,
      fromPageSize: 10
    }
  },
  mounted() {
    // 获取路由参数
    this.orderId = this.$route.query.id;
    this.fromPage = this.$route.query.page || 1;
    this.fromPageSize = this.$route.query.pageSize || 10;
    
    if (this.orderId) {
      this.getOrderDetail();
    } else {
      this.$message.error('缺少订单ID参数');
      this.goBack();
    }
  },
  methods: {
    getMeteringUnitLabel(row) {
      const devCharacterUnitMap = {
        'GPU节点': '台·日',
        'CPU节点': '台·月',
        '存储': 'T·月',
        '容器云': '卡·时',
        '其他': '台·月'
      };

      const meteringUnitLabelMap = {
        '1': '台·日',
        '2': '卡·时',
        '3': 'T·月',
        '4': '台·月'
      };

      // 优先使用 dev_character
      if (row.dev_character && devCharacterUnitMap[row.dev_character]) {
        return devCharacterUnitMap[row.dev_character];
      }

      // 其次使用 metering_unit 编码
      if (row.metering_unit && meteringUnitLabelMap[row.metering_unit]) {
        return meteringUnitLabelMap[row.metering_unit];
      }

      // 最后 fallback
      return row.metering_unit || '—';
    },
    formatStatusText(status) {
      const statusMap = {
        0: '禁用',
        1: '启用'
      };
      return statusMap[status] || '未知';
    },
    // 获取订单详情
    getOrderDetail() {
      // 这里使用与列表页相同的API，但需要根据ID获取单个订单详情
      // 假设后端提供 /api-30216/api/orders/:id 的接口
      this.$axios.get(`/api-30216/api/orders/${this.orderId}`)
        .then(response => {
          console.log(response);
          if (response.data) {
            this.orderDetail = response.data;
          } else {
            this.$message.error('未找到订单信息');
            this.goBack();
          }
        })
        .catch(error => {
          console.error('获取订单详情失败:', error);
          this.$message.error('获取订单详情失败');
          this.goBack();
        });
    },
    
    // 格式化日期 - 使用内置方法替代 util.formatDate
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 格式化订单类型
    formatOrderType(value) {
      const map = {
        0: '开口',
        1: '闭口',
        2: '售前测试'
      };
      return map[value] || '-';
    },

    // 格式化状态
    formatStatus(value) {
      const map = {
        0: '草稿',
        1: '待审核',
        2: '生效中',
        3: '已终止',
        4: '已到期'
      };
      return map[value] || '-';
    },

    // 返回列表页 - 修正路径为实际的订单列表路径
    goBack() {
      this.$router.push({
        path: '/api/orders', // 替换为实际的订单列表页面路径
        query: {
          page: this.fromPage,
          pageSize: this.fromPageSize
        }
      });
    },
    // 格式化金额显示（带货币符号）
    formatCurrency(row, column, cellValue, index) {
      const value = column ? cellValue : index.unit_price;
      const currency = this.orderDetail.currency || 'CNY';

      if (value == null || value === '') return '-';

      const symbolMap = {
        'CNY': '¥',
        'USD': '$',
        'EUR': '€',
        'HKD': 'HK$'
      };
      const symbol = symbolMap[currency] || currency;

      // 如果是数字，则格式化千分位
      const num = parseFloat(value);
      if (isNaN(num)) return '-';

      const formatted = num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return `${symbol}${formatted}`;
    },
  }
}
</script>

<style scoped>
.back-button{
  margin-left:20px;
}
.detail-card {
  margin: 20px;
}

.detail-item {
  display: flex;
  margin-bottom: 10px;
  min-height: 36px;
  align-items: center;
}

.detail-label {
  width: 120px;
  font-weight: bold;
  color: #606266;
  text-align: right;
  padding-right: 12px;
}

.detail-value {
  flex: 1;
  color: #303133;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
.detail-title h3{
  width: 120px;
  font-weight: bold;
  color: #606266;
  text-align: right;
  padding-right: 12px;
  font-size: 14px;
}
</style>